export const JobStatus = {
  PENDING: 'pending',
  OPEN: 'open',
  COUNTER: 'counter',
  FILLED: 'filled',
  COMPLETE: 'complete',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
};

const interviewColors = Object.freeze({
  [JobStatus.PENDING]: '#FDFFC9',
  [JobStatus.OPEN]: '#FDFFC9',
  [JobStatus.COUNTER]: '#FDFFC9',
  [JobStatus.FILLED]: '#C1F5B9',
  [JobStatus.COMPLETE]: '#99DAE3',
  [JobStatus.CANCELLED]: '#F8B5B5',
  [JobStatus.EXPIRED]: '#F8B5B5',
});

export const JobStatusMapper = {
  getInterviewColor: (it) => interviewColors[it],
};
